function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.313 12h7.375l-7.375-7.313V12zm4 6.688V16H10.688v2.688h10.625zm0 5.312v-2.688H10.688V24h10.625zM18.688 2.688l8 8v16c0 1.438-1.25 2.625-2.688 2.625H8c-1.438 0-2.688-1.188-2.688-2.625l.063-21.375A2.64 2.64 0 018 2.688h10.688z"
});

var SvgShareDoc = function SvgShareDoc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 32 32"
  }), _ref);
};

export default SvgShareDoc;